var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 360946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.38544 3.20108L7.12596 2.81817C7.12224 2.81269 7.11677 2.80476 7.1101 2.7951C7.09013 2.76614 7.0594 2.72158 7.03284 2.68049L7.03233 2.67971C6.29119 1.52713 5.04809 1.09362 4.05982 1.30476L7.38544 3.20108ZM7.38544 3.20108L7.7091 2.87064M7.38544 3.20108L7.7091 2.87064M7.7091 2.87064C7.82559 2.7517 7.94267 2.62247 8.05243 2.50133M7.7091 2.87064L8.05243 2.50133M13.3902 3.3933L13.3902 3.39322C13.0526 2.48226 12.3181 1.75946 11.4481 1.43753C10.5882 1.11933 9.59348 1.19042 8.6954 1.87062L13.3902 3.3933ZM13.3902 3.3933C13.8478 4.62742 13.5791 5.80334 12.9329 6.96765L12.9329 6.96766M13.3902 3.3933L12.9329 6.96766M12.9329 6.96766C11.9276 8.77927 10.4776 10.2242 8.85273 11.5292M12.9329 6.96766L8.85273 11.5292M8.05243 2.50133C8.11045 2.43729 8.16642 2.37551 8.21917 2.31871M8.05243 2.50133L8.21917 2.31871M8.21917 2.31871C8.38048 2.14502 8.53235 1.9942 8.69532 1.87068L8.21917 2.31871ZM8.85273 11.5292C7.99393 12.2186 6.89105 12.1901 6.01826 11.4706M8.85273 11.5292L6.01826 11.4706M6.01826 11.4706C4.52865 10.2421 3.18117 8.90545 2.19596 7.26591L6.01826 11.4706ZM2.19589 7.2658C1.58303 6.24505 1.22736 5.20413 1.40391 4.04072L2.19589 7.2658ZM1.40394 4.04056C1.61106 2.68044 2.58205 1.62156 4.05961 1.3048L1.40394 4.04056Z",
    stroke: "#178FFF",
    strokeWidth: 0.756233
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.dde7083226e60a4239cda55e9391bd7b.svg";
export { ForwardRef as ReactComponent };